/* eslint-disable react/no-array-index-key */
import React from 'react';

import { CallUs as CallUsModel } from 'models';
import PropTypes from 'prop-types';
import Container from 'blocks/Container/Container';
import { Row, Column } from 'hedron';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import ds from 'designsystem';
import ContactPerson from './ContactPerson';

const CallUs = (props) => {
  const {
    data: {
      people,
      htmlModifiers,
    },
  } = props;

  return (
    <HTMLModifiableBackground
      htmlModifiers={htmlModifiers}
      color={ds.brand('white')}
    >
      <Container>
        <Row style={{ paddingBottom: '70px' }}>
          {people.map((person, index) => (
            <Column
              md={6}
              key={person.id}
            >
              <ContactPerson
                data={person}
                index={index}
              />
            </Column>
          ))}
        </Row>
      </Container>
    </HTMLModifiableBackground>
  );
};
CallUs.propTypes = {
  data: PropTypes.instanceOf(CallUsModel).isRequired,
};

export default CallUs;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/index.jsx